import apiClient from '@/services/axios'

const getAll = async (token, date, roles) => {
  try {
    console.log(date, '<<<<DATE')
    const res = await apiClient.get('/dashboard', {
      params: {
        cancelToken: token,
        startDate: date,
      },
    })
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}
const getAllByProgram = async (type) => {
  try {
    const res = await apiClient.get(`/dashboard/program?type=${type}`)
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportProgramStatus = async (start, token, type) => {
  try {
    const res = await apiClient.get(
      `/report/program/status/new?start=${start}&type=${type}`,
      {
        cancelToken: token,
      },
    )
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}
// const reportProgramStatus = async (start, token) => {
//   try {
//     const res = await apiClient.get(`/report/program/status?start=${start}`, {
//       cancelToken: token,
//     })
//     return res.data
//   } catch (e) {
//     console.log('error when getting dashboard data with error: ' + e)
//     return []
//   }
// }
const reportProgramStatusByProgram = async (start, type, token) => {
  try {
    const res = await apiClient.get(
      `report/programType/status?start=${start}&type=${type}`,
      {
        cancelToken: token,
      },
    )
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportTerminateReason = async (date, status, token) => {
  try {
    const res = await apiClient.get(
      `/report/program/terminate?status=${status}&date=${date}`,
      {
        cancelToken: token,
      },
    )
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportArticleTotalViews = async (date, token) => {
  try {
    const res = await apiClient.get(
      `/report/articleReport/articleViews?start=${date}`,
      {
        cancelToken: token,
      },
    )
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportPatientByCity = async (date, token) => {
  try {
    const res = await apiClient.get(`/report/patient/city?date=${date}`, {
      cancelToken: token,
    })
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}
const reportPatientByCityPerProgram = async (type) => {
  try {
    const res = await apiClient.get(`/report/patient/city/program?type=${type}`)
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportPatientByProgram = async (programId, date) => {
  try {
    const res = await apiClient.get(
      `/report/patient/program?programId=${programId}&date=${date}`,
      {},
    )
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

const reportDoctorByCity = async (date, token) => {
  try {
    const res = await apiClient.get(`/report/doctor/city?date=${date}`, {
      cancelToken: token,
    })
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
}

export {
  getAll,
  reportProgramStatus,
  reportTerminateReason,
  reportPatientByCity,
  reportPatientByCityPerProgram,
  reportDoctorByCity,
  reportArticleTotalViews,
  reportPatientByProgram,
  getAllByProgram,
  reportProgramStatusByProgram,
}
